import axios from './_nestAxios'

export const obtenerAsSelect = () => axios.get('/roles', { params: { tipoConsulta: 'select' } })

export const actualizarxId = (_id, data) => axios.put(`/roles/${_id}`, data)
export const eliminarxId = _id => axios.delete(`/roles/${_id}`)
export const obtenerxIdAsEdicion = _id => axios.get(`/roles/${_id}`)

export const nuevo = data => axios.post('/roles', data)
export const duplicar = data => axios.post(`/roles/duplicar`, data)
